import React from "react";
import { Plus, Trash2, ChevronUp, ChevronDown } from "lucide-react";
import { useSection } from "./useSection";
import { Field, SaveBar } from "./ui";
import { ImageField } from "./ImageField";

export default function ServicesEditor({ logout }) {
  const { draft, setDraft, saving, save } = useSection("services", logout);
  const items = draft || [];

  const setItem = (i, k, v) => setDraft(items.map((s, idx) => (idx === i ? { ...s, [k]: v } : s)));
  const add = () => setDraft([...items, { id: `svc-${Date.now()}`, title: "", desc: "", img: "" }]);
  const remove = (i) => setDraft(items.filter((_, idx) => idx !== i));
  const move = (i, dir) => {
    const j = i + dir;
    if (j < 0 || j >= items.length) return;
    const next = items.slice();
    [next[i], next[j]] = [next[j], next[i]];
    setDraft(next);
  };

  return (
    <div>
      <SaveBar title="Servizi" description="I servizi mostrati nella griglia. Trascina l'ordine con le frecce." saving={saving} onSave={save} />

      <div className="space-y-5">
        {items.map((s, i) => (
          <div key={s.id || i} className="bg-white border border-navy/10 p-5 grid md:grid-cols-[1fr_auto] gap-5">
            <div className="space-y-4">
              <Field label={`Servizio ${i + 1} — Titolo`} value={s.title} onChange={(v) => setItem(i, "title", v)} />
              <Field label="Descrizione" value={s.desc} onChange={(v) => setItem(i, "desc", v)} textarea />
              <ImageField label="Immagine" value={s.img} onChange={(v) => setItem(i, "img", v)} logout={logout} />
            </div>
            <div className="flex md:flex-col items-center justify-start gap-2">
              <button onClick={() => move(i, -1)} disabled={i === 0} aria-label="Su" className="p-2 text-navy/40 hover:text-navy disabled:opacity-25"><ChevronUp size={18} /></button>
              <button onClick={() => move(i, 1)} disabled={i === items.length - 1} aria-label="Giù" className="p-2 text-navy/40 hover:text-navy disabled:opacity-25"><ChevronDown size={18} /></button>
              <button onClick={() => remove(i)} aria-label="Elimina" className="p-2 text-navy/30 hover:text-red-500"><Trash2 size={18} /></button>
            </div>
          </div>
        ))}
      </div>

      <button onClick={add} className="mt-6 inline-flex items-center gap-2 border border-navy/20 px-5 py-3 text-xs uppercase tracking-[0.18em] text-navy hover:border-gold hover:text-gold transition-colors">
        <Plus size={15} /> Aggiungi servizio
      </button>
    </div>
  );
}
